// GCODEGIG — código de validación de ingresos y egresos, replicado del PRG de
// Clipper (.claude/docs/PRUEBA.PRG).
//
// A diferencia de NSAUTDTO no hay ida y vuelta: con los datos del comprobante
// y la fecha del día se obtiene un código de 4 dígitos, y el Clipper lo valida
// recalculándolo con los mismos datos. El importe tiene que coincidir al
// centavo: un centavo de diferencia da otro código.
//
// La fecha entra solo como día y mes (sin año), tal como está en el PRG.
//
// Aritmética pura, sin imports, para testearla en Node
// (tests/gcodegig.test.mjs).

// Semillas (números primos) para mezclar cada parámetro.
const SEED_SUC = 3571;
const SEED_TIP = 6701;
const SEED_COD = 8209;
const SEED_IMP = 2749;
const SEED_FEC = 1297;

/**
 * @param {number} suc      id de sucursal (el de LCApii, que es el SUC del Clipper)
 * @param {Date}   fecha    la del día
 * @param {string} tipo     "EG" o "IG"
 * @param {number} nro      número del comprobante, > 0
 * @param {number} importe  en pesos con centavos; se toma el valor absoluto
 * @returns {number} código de 4 dígitos, o -1 con parámetros incorrectos
 */
export function gcodegig(suc, fecha, tipo, nro, importe) {
  if (!Number.isInteger(suc) || suc < 0) return -1;
  if (!(fecha instanceof Date) || isNaN(fecha)) return -1;

  const tip = String(tipo ?? "").toUpperCase().padEnd(2).slice(0, 2);
  if (tip !== "EG" && tip !== "IG") return -1;

  if (!Number.isInteger(nro) || nro <= 0) return -1;
  if (typeof importe !== "number" || isNaN(importe)) return -1;

  const nimp = Math.round(Math.abs(importe) * 100);
  if (nimp === 0) return -1;

  const ntip = tip === "IG" ? 17 : 43;

  let naux = (fecha.getDate() * SEED_FEC + (fecha.getMonth() + 1) * SEED_FEC) % 5000;
  naux += (suc * SEED_SUC) % 50000;
  naux += (ntip * SEED_TIP) % 50000;
  naux += (nro * SEED_COD) % 50000;
  naux += (nimp % 46337) * SEED_IMP;

  return naux % 10000;
}
